window.addEventListener("DOMContentLoaded", (event) => {
	theme.sliderDesktop();
    let tabBtns = document.querySelectorAll('.product-tabination .tablinks');
    if (tabBtns) {
      let tabContent = document.querySelectorAll('.tab-description .tabcontent');
      tabBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          tabBtns.forEach(btn => btn.classList.remove('active'))
          tabContent.forEach(btn => btn.classList.remove('active'))
          e.currentTarget.classList.add('active');
          let targetID = e.currentTarget.dataset.id;
          tabContent.forEach(tab => {
            if (tab.id == targetID) {
              tab.classList.add('active');
              theme.sliderDesktop();
            } else { 
              tab.classList.remove('active')
            }
          })
          
        })
      })
    }
   var parentElement = document.querySelector('.product-tabination');
    var firstDivChild = parentElement.querySelector('button:first-child');
    if(!firstDivChild.classList.contains('active')){
      firstDivChild.classList.add('active');
    }
    var childElement = document.querySelector('.tab-description');
    var firstChild = childElement.querySelector('div:first-child');
    if(!firstChild.classList.contains('active')){
      firstChild.classList.add('active');
    }
  });

  theme.sliderDesktop = () => {
	if (window.innerWidth > 768) {
		for (item of document.querySelectorAll('.desktop_slids .desktop_slids_inner > div'))
		item.style.scrollSnapAlign = 'center';

		const gallery = document.querySelectorAll('.desktop_slids');
		gallery.forEach(btn => {
			const gallery_scroller = btn.querySelector('.desktop_slids_inner');
			const gallery_item_size = gallery_scroller.querySelector('div').clientWidth;
			
			btn.querySelector('.btn.next').addEventListener('click', scrollToNextPage);
			btn.querySelector('.btn.prev').addEventListener('click', scrollToPrevPage);
			
			function scrollToNextPage() {
				gallery_scroller.scrollBy(gallery_item_size, 0);
			}
			function scrollToPrevPage() {
				gallery_scroller.scrollBy(-gallery_item_size, 0);
			}
		});
		
	}
}
  
  